
import { Vue } from "vue-class-component";

export default class Check extends Vue {}
